import { createContext, ReactNode } from 'react';
import UserStore from '../store/UserStore';

interface IAppContext {
    user: UserStore;
}

interface AppContextProviderProps {
    children: ReactNode;
}

const userStore = new UserStore();

const AppContext = createContext<IAppContext>({
    user: userStore,
});

const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
    return (
        <AppContext.Provider value={{ user: userStore }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppContextProvider };